import React, {useEffect, useState} from 'react'
import {FieldValues, UseFormRegister} from 'react-hook-form'


interface FormInputProps {
  label?: string
  required?: boolean
  type?: 'string' | 'number' | 'password' | 'email'
  value?: string
  onChange?: (value?: string) => void
  placeholder?: string
  error?: string
  zodRequired?: boolean
  name: string
  register?: UseFormRegister<FieldValues>
}
export const FormInput = ({
  label,
  required,
  type = 'string',
  value: defaultValue,
  onChange,
  placeholder,
  name,
  error,
  zodRequired,
  register,
}: FormInputProps) => {
  const [value, setValue] = useState<string>(defaultValue)

  useEffect(() => {
    setValue(defaultValue)
  }, [defaultValue])

  return (
    <div className='input-container'>
      {label && (
        <p>
          {label}
          {required || zodRequired && <span>*</span>}
        </p>
      )}
      <input
        required={zodRequired ? false : required}
        name={name}
        placeholder={placeholder}
        type={type}
        value={value}
        onChange={(e) => {
          setValue(e.target.value)
          onChange?.(e.target.value)
        }}
        {...register?.(name)}
      />
      {
        error && <p className='error'>{error}</p>
      }
    </div>
  )
}
